export function navigateToRepoPulls(path: string) {
  window.location.assign(path)
}
